/* State Codes */
export const COUNTRY_CODE_LOOKUP = {
  NT: 'Darwin',
  QLD: 'Queensland',
  NSW: 'Sydney',
  VIC: 'Victoria',
  TAS: 'Hobart',
  WA: 'Perth',
  SA: 'Adelaide',
  ACT: 'Canberra'
}

/* Result Status */
export const RESULT_STATUS_INTERIM = 'Interim'
export const RESULT_STATUS_FINAL = 'Final'
export const RESULT_STATUS_PARTIAL_PAY = 'Partial Pay'
export const RESULT_STATUS_PROTEST = 'Protest'
export const RESULT_STATUS_PENDING = 'Pending'
export const RESULT_STATUS_RERESULT = 'Re-result'
export const RESULT_STATUS_ABANDONED = 'Abandoned'

export const RESULT_STATUS_LOOKUP = {
  0: RESULT_STATUS_INTERIM,
  1: RESULT_STATUS_FINAL,
  2: RESULT_STATUS_PARTIAL_PAY,
  3: RESULT_STATUS_PROTEST,
  4: RESULT_STATUS_PENDING,
  5: RESULT_STATUS_RERESULT,
  6: RESULT_STATUS_ABANDONED
}

/* Race Status */
export const RACE_STATUS_UNKNOWN = 'Unknown'
export const RACE_STATUS_OPEN = 'Open'
export const RACE_STATUS_CLOSED = 'Closed'
export const RACE_STATUS_INTERIM = 'Interim'
export const RACE_STATUS_FINAL = 'Final'
export const RACE_STATUS_INPROGESS = 'In Progress'
export const RACE_STATUS_BEHINDGATES = 'Behind Gates'
export const RACE_STATUS_PASTPOST = 'Past Post'
export const RACE_STATUS_ABANDONED = 'Abandoned'
export const RACE_STATUS_PROTEST = 'Pro Test'

export const RACE_STATUS_LOOKUP = {
  0: RACE_STATUS_UNKNOWN,
  1: RACE_STATUS_OPEN,
  2: RACE_STATUS_CLOSED,
  3: RACE_STATUS_INTERIM,
  4: RACE_STATUS_FINAL,
  5: RACE_STATUS_INPROGESS,
  6: RACE_STATUS_BEHINDGATES,
  7: RACE_STATUS_PASTPOST,
  8: RACE_STATUS_ABANDONED,
  9: RACE_STATUS_PROTEST
}

/* Scratching Types */
export const STARTER = 'Starter'
export const SCRATCHED = 'Scratched'
export const LATESCRATCHED = 'Late Scratched'

export const STATUSINDICATOR_VALUE = {
  0: STARTER,
  1: SCRATCHED,
  2: LATESCRATCHED
}

/* TrackCondition Types */
export const TRACKCONDITION_TRANSLATION = {
  UNKNOWN: 'Unkown',
  UNKNOWN_CONDITION: 'Unknown',
  FIRM1: 'Firm 1',
  FIRM2: 'Firm 2',
  GOOD3: 'Good 3',
  GOOD4: 'Good 4',
  SOFT5: 'Soft 5',
  SOFT6: 'Soft 6',
  SOFT7: 'Soft 7',
  HEAVY8: 'Heavy 8',
  HEAVY9: 'Heavy 9',
  HEAVY10: 'Heavy 10',
  DEAD: 'Dead',
  DIRT: 'Dirt',
  EASY: 'Easy',
  FAIR: 'Fair',
  FAST: 'Fast',
  GOOD: 'Good',
  HEAVY: 'Heavy',
  SAND: 'Sand',
  SLOW: 'Slow',
  VERYHEAVY: 'Very Heavy',
  FIRM: 'Firm',
  SOFT: 'Soft'
}

export const TRACKCONDITION = {
  UNKNOWN_CONDITION: null,
  FIRM1: 'Fast',
  FIRM2: 'Fast',
  GOOD3: 'Good',
  GOOD4: 'Good',
  SOFT5: 'Dead',
  SOFT6: 'Slow',
  SOFT7: 'Slow',
  HEAVY8: 'Heavy',
  HEAVY9: 'Heavy',
  HEAVY10: 'Heavy',
  DEAD: 'Dead',
  DIRT: 'Dead',
  EASY: 'Dead',
  FAIR: 'Good',
  FAST: 'Fast',
  GOOD: 'Good',
  HEAVY: 'Heavy',
  SAND: 'Slow',
  SLOW: 'Slow',
  VERY_HEAVY: 'Heavy',
  FIRM: 'Good',
  SOFT: 'Slow',
  SYNTHETIC: 'Synthetic'
}

export const RACESTATUS = {
  UNKNOWN: true,
  OPEN: 'Open',
  CLOSED: 'Closed',
  INTERIM: 'Interim/Paying',
  FINAL: 'Interim/Paying',
  IN_PROGRESS: 'Closed',
  BEHIND_GATES: 'Open',
  PAST_POST: 'Closed',
  ABANDONED: 'Abandoned',
  PROTEST: 'Closed'
}

/* Meeting Types */
export const MEETING_TYPE_GALLOPS = 'HorseRacing'
export const MEETING_TYPE_GREYHOUNDS = 'GreyHoundRacing'
export const MEETING_TYPE_HARNESS = 'HarnessRacing'

/* Track Direction */
export const TRACKDIRECTION = {
  'AUS/QLD': 'clockwise',
  'AUS/NSW': 'clockwise',
  'AUS/VIC': 'anti-clockwise',
  'AUS/SA': 'anti-clockwise',
  'AUS/TAS': 'anit-clockwise',
  'AUS/WA': 'anti-clockwise'
}

export const RACE_TYPE_IMAGE = {
  HarnessRacing: '/img/race_types/DO_RaceType_Harness-BLACK.svg',
  GreyHoundRacing: '/img/race_types/DO_RaceType_Greyhounds-BLACK.svg',
  HorseRacing: '/img/race_types/DO_RaceType_Gallops-BLACK.svg',
  HARNESS: '/img/race_types/DO_RaceType_Harness-BLACK.svg',
  GREYHOUND: '/img/race_types/DO_RaceType_Greyhounds-BLACK.svg',
  THOROUGHBRED: '/img/race_types/DO_RaceType_Gallops-BLACK.svg'
}

export const SPEEDMAP_LABELS = {
  LEAD: 0,
  'LEAD/HANDY': 2,
  HANDY: 4,
  'HANDY/MID': 6,
  MID: 8,
  REAR: 10
}

export const DATA_BASE_KEY_LIST = [
  'chromeGrouping',
  'chromeTabs',
  'finishingPosition',
  'finishPositionOrMargin',
  'margin',
  'spell',
  'track',
  'trackConditions',
  'distance',
  'classes',
  'runnerBlackbook',
  'runnerBlackbookComments',
  'jockeyBlackbook',
  'jockeyBlackbookComments',
  'trainerBlackbook',
  'trainerBlackbookComments',
  'sortFieldsBy',
  'currentVenue',
  'isAutoHide',
  'marketRange',
  'marketPercentage',
  'oddsToUse',
  'oddsFormat',
  'ratingToUse',
  'globalRunnerNotes'
]

export const CUSTOM_CHROME_TAB = [
  'Blackbook',
  'Horse Search'
]

export const RESULTS_COLUMNS = [
  { source: 'V', type: 'WIN', display: 0, label: 'Tote' },
  { source: 'N', type: 'WIN', display: 0, label: 'Tote' },
  { source: 'Q', type: 'WIN', display: 0, label: 'Tote' },
  { source: 'OP', type: 'WIN', display: 0, label: 'Fixed' },
  { source: 'BF', type: 'WIN', display: 0, label: 'Fixed' },
  { source: 'SPC', type: '', display: 0 },
  { source: 'V', type: 'PLACE', display: 0, label: 'Tote' },
  { source: 'N', type: 'PLACE', display: 0, label: 'Tote' },
  { source: 'Q', type: 'PLACE', display: 0, label: 'Tote' },
  { source: 'BF', type: 'PLACE', display: 0, label: 'Fixed' }
]

export const ALL_BOOKIES_CODES = [
  { source: 'SB2' },
  { source: 'LB' },
  { source: 'SB5' },
  { source: 'N' },
  { source: 'TS_N' },
  { source: 'TS_V' },
  { source: 'V' },
  { source: 'Q' },
  { source: 'TS_Q' },
  { source: 'BE' },
  { source: 'CB' },
  { source: 'BB2' },
  { source: 'TS2' },
  { source: 'BT' },
  { source: 'OB' },
  { source: 'LB2' },
  { source: 'LB2U' },
  { source: 'UB' },
  { source: 'CB2' },
  { source: 'TB2' },
  { source: 'OP' },
  { source: 'GT' },
  { source: 'ND' },
  { source: 'BB3' },
  { source: 'BB4' },
  { source: 'BD' },
  { source: 'RB3' },
  { source: 'BD2' },
  { source: 'DD' },
  { source: 'BF' },
  { source: 'NZ' },
  { source: 'OP' },
  { source: 'BV' },
  { source: 'SB6' },
  { source: 'CB3' },
  { source: 'BS3' },
  { source: 'RB2' },
  { source: 'WH' },
  { source: 'PP2' },
  { source: 'SBU' },
  { source: 'UB_U' },
  { source: '888' },
  { source: 'BW2' },
  { source: 'WB3' }
  // { source: '10B' }
]

export const DEFAULT_RUNNER = {
  age: null,
  allowanceWeight: null,
  apprenticeIndicator: null,
  emergencyIndicator: null,
  barrier: null,
  colour: null,
  dam: null,
  finalPosition: null,
  formHistory: [],
  jockey: null,
  jockeyID: null,
  jockeyId: null,
  meetingId: null,
  name: '',
  oddsToDisplay: null,
  owners: '',
  prices: [],
  prizeMoney: null,
  raceExternalId: null,
  raceId: null,
  raceNumber: null,
  rating: null,
  result: null,
  runner: {
    id: ''
  },
  runnerStatistics: {
    career: {
      all: {
        averagePrizeMoneyWon: null,
        firsts: null,
        numberOfRuns: null,
        placePercentage: null,
        rating: null,
        seconds: null,
        thirds: null,
        winPercentage: null
      }
    },
    conditionPlaces: [],
    distancePlaces: [],
    firstUp: {},
    lastSeason: {},
    secondUp: {},
    trackAndDistancePlaces: [],
    trackPlaces: []
  },
  scratched: false,
  selectedTabTypeName: null,
  sex: null,
  silksColour: null,
  sire: null,
  speedmapPosition: null,
  tabNo: null,
  tabNumber: null,
  tabType: null,
  trainer: null,
  trainerID: null,
  trainerId: null,
  weightAllocated: null,
  weightTotal: null
}

export const SOUTHERN_HEMISPHER_THOROUGHBRED_2022 = [
  'AGO',
  'ARG',
  'AUS',
  'BWA',
  'BRA',
  'BDI',
  'CHL',
  'COL',
  'COM',
  'COD',
  'ECU',
  'GNQ',
  'SWZ',
  'FJI',
  'GAB',
  'IDN',
  'KEN',
  'KIR',
  'LSO',
  'MDG',
  'MWI',
  'MDV',
  'MUS',
  'MOZ',
  'NAM',
  'NRU',
  'NZL',
  'PNG',
  'PRY',
  'PER',
  'COD',
  'RWA',
  'WSM',
  'STP',
  'SYC',
  'SLB',
  'SOM',
  'ZAF',
  'TZA',
  'TON',
  'TUV',
  'UGA',
  'URY',
  'VUT',
  'ZMB',
  'ZWE'
]

export const BARRIER_TRIAL = ['Barrier Trial', 'BTrial']

export const LOGO_BASE_64 = 'data:image/png;base64,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'

export const DF_SUBSCRIPTION_PRODUCTCODE = 'DF'
export const DF_VALID_SUBSCRIPTION_CODES = [
  'SUBSCRIPTION_STANDARD_WITH_DYNAMICFORM',
  'SUBSCRIPTION_PLUS_WITH_DYNAMICFORM'
]
